import { Dialog, Transition } from '@headlessui/react'
import { Fragment, useRef } from 'react'
import { Link } from 'react-router-dom'

export default function ProductDetailModal({ open, setOpen, productDetail }) {

    const cancelButtonRef = useRef(null)

    return (
        <Transition.Root show={open} as={Fragment}>
            <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={setOpen}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </Transition.Child>

                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-6xl">
                                <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                                    <div>

                                        <div className="mt-5 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-12">

                                            <div className="sm:col-span-3">
                                                <div className="min-w-0 flex-auto">
                                                    <p className="text-sm font-semibold leading-6 text-gray-900">Product Name</p>
                                                    <p className="mt-1 truncate text-sm leading-5 text-gray-500">{productDetail.ProductName || "NA"}</p>
                                                </div>
                                            </div>


                                        </div>

                                        <div className="mt-5">
                                            <div className="mt-5 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-12">
                                                <div className="sm:col-span-3">
                                                    <div className="min-w-0 flex-auto">
                                                        <p className="text-sm font-semibold leading-6 text-gray-900">Product Category</p>
                                                        <p className="mt-1 truncate text-sm leading-5 text-gray-500">{productDetail.PrdtCategory || "NA"}</p>
                                                    </div>
                                                </div>
                                                <div className="sm:col-span-3">
                                                    <div className="min-w-0 flex-auto">
                                                        <p className="text-sm font-semibold leading-6 text-gray-900">Product SubCategory</p>
                                                        <p className="mt-1 truncate text-sm leading-5 text-gray-500">{productDetail.SubCategory || "NA"}</p>
                                                    </div>
                                                </div>
                                                <div className="sm:col-span-3">
                                                    <div className="min-w-0 flex-auto">
                                                        <p className="text-sm font-semibold leading-6 text-gray-900">Properties</p>
                                                        <p className="mt-1 truncate text-sm leading-5 text-gray-500">{productDetail.Properties || "NA"}</p>
                                                    </div>
                                                </div>
                                                <div className="sm:col-span-3">
                                                    <div className="min-w-0 flex-auto">
                                                        <p className="text-sm font-semibold leading-6 text-gray-900">Application</p>
                                                        <p className="mt-1 truncate text-sm leading-5 text-gray-500">{productDetail.Application || "NA"}</p>
                                                    </div>
                                                </div>
                                                <div className="sm:col-span-3">
                                                    <div className="min-w-0 flex-auto">
                                                        <p className="text-sm font-semibold leading-6 text-gray-900">Materials</p>
                                                        <p className="mt-1 truncate text-sm leading-5 text-gray-500">{productDetail.Materials || "NA"}</p>
                                                    </div>
                                                </div>
                                                <div className="sm:col-span-3">
                                                    <div className="min-w-0 flex-auto">
                                                        <p className="text-sm font-semibold leading-6 text-gray-900">Product Specifications</p>
                                                       <Link to={productDetail.PdfFile}> <p className="mt-1 truncate text-sm leading-5 text-blue-700 underline cursor-pointer">Download</p></Link>
                                                    </div>
                                                </div>
                                               

                                            </div>
                                        </div>
                                        <div className='mt-5'>
                                            <div className="grid grid-cols-1 gap-10 mt-5 sm:grid-cols-2 lg:grid-cols-8">
                                                {productDetail.ImageUrls.map((img) => (
                                                    <img
                                                        src={img}
                                                        alt="Project"
                                                        className="w-full  shadow-md object-cover cursor-pointer"
                                                    />
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root >
    )
}
